import {Nullable, NullableKeys} from '@fl/cmsch-fe-library';

/** Redux form name for the bull preference form. */
export const matingBullPreferencesFormName = 'matingBullPreferences';

/** Form values used by the bull preference recalculation form. */
export type MatingBullPreferencesFormValues = NullableKeys<{
    /** Bull percentage shares keyed by row. */
    bullPreferences: Array<Nullable<number>>,
}>;
